import React, { useState, useEffect } from 'react';
import { TouchableOpacity, TextInput, View, Text, AsyncStorage } from 'react-native';
import { Button } from 'qunar-react-native';
import { HOTS } from '../../Constant/urls';
import styles from './style';

export default function DebugButton() {
    const [textVal, setTextVal] = useState('');
    const [show, setShow] = useState(false);

    useEffect(()=>{
        AsyncStorage.getItem('@componentOrderHost')
            .then((res) => {
                setTextVal(res || HOTS);
            })
    },[])

    const handlePress = () => {
        if (textVal) {
            AsyncStorage.setItem('@componentOrderHost', textVal);
            setTextVal(textVal);
        }
        setShow(false);
    }

    const handledel = () => {
        AsyncStorage.setItem('@componentOrderHost', '');
        setShow(false);
        setTextVal(HOTS)
    }

    return (
        <View style={styles.debugWrapper}>
            <TouchableOpacity onPress={() => setShow(!show)}>
                <Text style={{backgroundColor: 'red', color: 'white', padding: 2}}>Beta环境切换</Text>
            </TouchableOpacity>
            {
                show &&
                (
                    <View>
                        <TextInput
                            style={styles.inputText}
                            editable
                            value={textVal}
                            onChangeText={(text) => setTextVal(text)}
                        />
                        <View style={styles.buttonWrapper}>
                            <Button style={{ marginRight: 20 }} text="保存" onPress={handlePress} />
                            {
                                textVal !== HOTS && <Button text="一键清除" onPress={handledel} />
                            }
                        </View>
                    </View>
                )
            }
        </View>
    );
};
